export default __webpack_public_path__ + "static/us-map-alaska-e14ca34d949972bd7ae19d23b960f649.svg";